import { createContext } from 'react'
import { SearchOptions } from '@giphy/js-fetch-api'

type SearchOptionsContextProps = {
    setType: (type: 'gifs' | 'stickers') => void
    setSort: (sort: 'relevant' | 'recent') => void
    setSearchResponseId: (id: string) => void
    searchResponseId: string
} & SearchOptions
const SearchOptionsContext = createContext({} as SearchOptionsContextProps)

export default SearchOptionsContext
